import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import logo from 'styles/images/svg/IBAlogo.svg';
import { updateUser } from 'actions/userActions';
import { getChatMessages } from 'actions/chatActions';
import ActionModal from 'pages/ManageStudents/ActionModal';
import UploadAvatarModal from 'components/UploadAvatarModal';
import UserActions from '../UserActions';
import Notifications from '../Notifications';
import {
  HeaderWrapper,
  HeaderContainer,
  UserPanel,
  HeaderLogo,
  LockedUserName,
} from './HeaderStyled';
import Subscriber from '../Subscriber';

export const Header = ({
  isAuthenticated,
  applicants,
  lockedDisplayName,
  user,
  updateUser,
  getChatMessages,
}) => {
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(
    false,
  );
  const onVisibilityChange = (condition) => setIsUserDropdownOpen(condition);
  const onNotificationVisibilityChange = (condition) => setIsNotificationDropdownOpen(condition);

  const handleAvatarUpload = async (base64) => {
    try {
      await updateUser(user.pk, { avatar: base64.split(',').pop() }, true);
      setModalOpen(false);
      setModalError(false);
      getChatMessages();
    } catch (error) {
      setModalError(true);
    }
  };

  return (
    <>
      <HeaderWrapper
        isDropdownOpen={isUserDropdownOpen || isNotificationDropdownOpen}
      >
        <HeaderContainer>
          <a href="http://iba-digital.de">
            <HeaderLogo src={logo} alt="logo" />
          </a>

          {isAuthenticated && (
            <UserPanel>
              <Subscriber />
              <Notifications
                applicants={applicants}
                isDropdownOpen={isNotificationDropdownOpen}
                onVisibilityChange={onNotificationVisibilityChange}
                isUserDropdownOpen={isUserDropdownOpen}
              />
              <UserActions
                isDropdownOpen={isUserDropdownOpen}
                onVisibilityChange={onVisibilityChange}
                onModalOpen={() => setModalOpen(true)}
              />
            </UserPanel>
          )}

          {/* Gesperrter Zustand (offener Loeschvorgang): nur der Name. Alles
              Interaktive haengt an isAuthenticated und faellt hier weg, weil
              currentUser hinter der Sperre mit 403 antwortet -- Glocke,
              Aufklapp-Menue und Avatar-Upload liefen dort saemtlich ins Leere. */}
          {!isAuthenticated && !!lockedDisplayName && (
            <UserPanel>
              <LockedUserName>{lockedDisplayName}</LockedUserName>
            </UserPanel>
          )}
        </HeaderContainer>
      </HeaderWrapper>
      <ActionModal isOpen={modalOpen} onCloseModal={() => setModalOpen(false)}>
        <UploadAvatarModal
          user={user}
          onUpload={handleAvatarUpload}
          onClose={() => setModalOpen(false)}
          error={modalError}
        />
      </ActionModal>
    </>
  );
};

Header.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  lockedDisplayName: PropTypes.string,
  updateUser: PropTypes.func.isRequired,
  getChatMessages: PropTypes.func.isRequired,
  applicants: PropTypes.arrayOf(PropTypes.object),
  // Note: `role` is intentionally NOT declared here. Header neither reads nor
  // forwards it (the role badge lives in UserActions, which has its own connect
  // + role mapping). Declaring it `isRequired` while mapStateToProps never
  // supplies it produced a spurious dev-only PropTypes warning.
  user: PropTypes.shape({
    pk: PropTypes.string,
    first_name: PropTypes.string,
    email: PropTypes.string,
    birthday: PropTypes.string,
    phone: PropTypes.string,
    location: PropTypes.string,
    last_name: PropTypes.string,
    avatar: PropTypes.string,
  }),
};

Header.defaultProps = {
  applicants: [],
  lockedDisplayName: '',
  user: null,
};

// Offener Loeschvorgang? Dann zeigt der Kopfbereich nur Logo und Namen.
// 🔴 Diese Frage haengt AM VORGANG, nicht an `isAuthenticated`. Der erste
// Entwurf tat das und war falsch: In der Sitzung, in der jemand den Vorgang
// gerade ausgeloest hat, liegt `currentUser` bereits im Store -- die Sperre
// wirkt nur auf NEUE Anfragen. Der Kopfbereich zeigte dort das volle Panel mit
// Glocke, Rollen-Badge und Aufklapp-Menue, deren Klicks saemtlich in 403 liefen.
// Erst nach einem Reload waere `data` null gewesen. Am Browser gemessen, nicht
// hergeleitet.
const istGesperrt = (pseudonymization) => !!(
  pseudonymization
  && pseudonymization.data
  && pseudonymization.data.state === 'open');

export const mapStateToProps = ({
  currentUser: { data }, applicants, pseudonymization,
}) => ({
  isAuthenticated: !!data && !istGesperrt(pseudonymization),
  // Der Name kommt aus der Vorgangsantwort: nach einem Reload ist `currentUser`
  // leer (403 auf /internship/esuser/), die Vorgangsantwort aber immer da.
  lockedDisplayName: (istGesperrt(pseudonymization)
    && pseudonymization.data.process
    && pseudonymization.data.process.display_name) || '',
  user: {
    pk: data && data.pk,
    first_name: data && data.user && data.user.first_name,
    last_name: data && data.user && data.user.last_name,
    avatar: data && data.avatar,
    email: data && data.user && data.user.email,
    birthday: data && data.birthday,
    phone: data && data.phone,
    location: data && data.location,
  },
  applicants: applicants && applicants.data ? applicants.data : [],
});

export default connect(mapStateToProps, { updateUser, getChatMessages })(
  Header,
);
